import { Emergency, View, Notification, Video } from "grommet-icons";
import React from "react";
import StandardColors from "../../../../../../../util/StandardColors";
import videoCallJoin from '../../../../../../../assets/video-call-join.png';
import videoCallleft from '../../../../../../../assets/left-video-call.png';
import vitalUpload from '../../../../../../../assets/vital-upload.png';

export const EventTypeToTextMapper: {
  [key: string]: {
    text: string;
    icon: React.ReactNode;
  };
} = {
  EMERGENCY_REGISTERED: {
    text: "Medical Emergency Reported",
    icon: <Emergency color={StandardColors.black_80} />,
  },
  EMS_NOTIFIED: {
    text: "EMS Notified",
    icon: <Notification color={StandardColors.black_80} />,
  },
  EMS_VIEWED: {
    text: "EMS Viewed Medical Emergency",
    icon: <View color={StandardColors.black_80} />,
  },
  EMS_CALLED: {
    text: "EMS Joined Videocall",
    icon: <img src={videoCallJoin} alt="Joined Videocall" />,
  },
  CREW_CALLED: {
    text: "Crew Joined Videocall",
    icon: <img src={videoCallJoin} alt="Joined Videocall" />,
  },
  EMS_CALL_ENDED: {
    text: "EMS Left Videocall",
    icon: <img src={videoCallleft} alt="Videocall Ended" />,
  },
  CREW_CALL_ENDED: {
    text: "Crew Left Videocall",
    icon: <img src={videoCallleft} alt="Videocall Ended" />,
  },
};
